import { createAction, handleActions } from 'redux-actions';
import { takeLatest } from 'redux-saga/effects';
import * as apiSvcMngt from 'apiSaga/apiServiceMngt';
import createRequestSaga from 'apiSaga/createRequestSaga';

/***** 액션 타입 선언 *****/

// 0. Response 초기화
const INIT_SERVICE_MNGT_RESP = 'svcMngt/INIT_SERVICE_MNGT_RESP';
const INIT_USAGE_STATUS_LIST_RESP = 'svcMngt/INIT_USAGE_STATUS_LIST_RESP';
const INIT_INSERT_USAGE_STUS_RESP = 'svcMngt/INIT_INSERT_USAGE_STUS_RESP';
const INIT_USAGE_SIDE_LIST_RESP = 'svcMngt/INIT_USAGE_SIDE_LIST_RESP';
const INIT_INSERT_ACNT_USAGE_INFO_RESP = 'svcMngt/INIT_INSERT_ACNT_USAGE_INFO_RESP';
const INIT_UPDATE_RCPT_INFO_RESP = 'svcMngt/INIT_UPDATE_RCPT_INFO_RESP';
const INIT_USAGE_DETAIL_INFO_RESP = 'svcMngt/INIT_USAGE_DETAIL_INFO_RESP';
const INIT_SAVE_ACNT_USAGE_INFO_RESP = 'svcMngt/INIT_SAVE_ACNT_USAGE_INFO_RESP';
const INIT_INSERT_RCPT_STOP_INFO_RESP = 'svcMngt/INIT_INSERT_RCPT_STOP_INFO_RESP';
const INIT_INSERT_TRANS_STUS_INFO_RESP = 'svcMngt/INIT_INSERT_TRANS_STUS_INFO_RESP';
const INIT_USAGE_CODE_LIST_RESP = 'svcMngt/INIT_USAGE_CODE_LIST_RESP';
const INIT_UPDATE_CANCEL_RCPT_RESP = 'svcMngt/INIT_UPDATE_CANCEL_RCPT_RESP';
const INIT_DOC_USE_LIST_RESP = 'svcMngt/INIT_DOC_USE_LIST_RESP';
const INIT_USAGE_LIST_RESP = 'svcMngt/INIT_USAGE_LIST_RESP';
const INIT_EXCEL_USAGE_LIST_RESP = 'svcMngt/INIT_EXCEL_USAGE_LIST_RESP';
const INIT_INSERT_PRCS_INFO_RESP = 'svcMngt/INIT_INSERT_PRCS_INFO_RESP';
const INIT_ADMIN_USE_LIST_RESP = 'svcMngt/INIT_ADMIN_USE_LIST_RESP';
const INIT_INSERT_LIST_PRCS_INFO_RESP = 'svcMngt/INIT_INSERT_LIST_PRCS_INFO_RESP';
const INIT_INSERT_RCV_GROUP_INFO_RESP = 'svcMngt/INIT_INSERT_RCV_GROUP_INFO_RESP';
const INIT_RECV_LIST_RESP = 'svcMngt/INIT_RECV_LIST_RESP';
const INIT_REV_GROUP_LIST_RESP = 'svcMngt/INIT_REV_GROUP_LIST_RESP';
const INIT_GRP_NM_LIST_RESP = 'svcMngt/INIT_GRP_NM_LIST_RESP';
const INIT_SAVE_RCV_GROUP_INFO_RESP = 'svcMngt/INIT_SAVE_RCV_GROUP_INFO_RESP';
const INIT_DELETE_RCV_GROUP_INFO_RESP = 'svcMngt/INIT_DELETE_RCV_GROUP_INFO_RESP';
const INIT_SYS_MLIST_RESP = 'svcMngt/INIT_SYS_MLIST_RESP';
const INIT_TUS_CODE_L_RESP = 'svcMngt/INIT_TUS_CODE_L_RESP';
const INIT_TUS_CODE_L_DETAIL_RESP = 'svcMngt/INIT_TUS_CODE_L_DETAIL_RESP';
const INIT_DSBTR_LIST_RESP = 'svcMngt/INIT_DSBTR_LIST_RESP';
const INIT_DELETE_TUS_CODE_L_RESP = 'svcMngt/INIT_DELETE_TUS_CODE_L_RESP';
const INIT_UPDATE_TUS_CODE_L_RESP = 'svcMngt/INIT_UPDATE_TUS_CODE_L_RESP';
const INIT_INSERT_TUS_CODE_EXCEL_RESP = 'svcMngt/INIT_INSERT_TUS_CODE_EXCEL_RESP';
const INIT_INSERT_TUS_CODE_L_RESP = 'svcMngt/INIT_INSERT_TUS_CODE_L_RESP';
const INIT_CHECK_EXCEL_FILE_RESP = 'svcMngt/INIT_CHECK_EXCEL_FILE_RESP';
const INIT_DELETE_RCV_INFO_RESP = 'svcMngt/INIT_DELETE_RCV_INFO_RESP';
const INIT_INSERT_ALARM_MNGT_RESP = 'svcMngt/INIT_INSERT_ALARM_MNGT_RESP';
const INIT_ALARM_DETAIL_RESP = 'svcMngt/INIT_ALARM_DETAIL_RESP';
const INIT_SAVE_ALARM_MNGT_RESP = 'svcMngt/INIT_SAVE_ALARM_MNGT_RESP';
const INIT_DELETE_NTCN_INFO_RESP = 'svcMngt/INIT_DELETE_NTCN_INFO_RESP';
const INIT_NTCN_LIST_RESP = 'svcMngt/INIT_NTCN_LIST_RESP';
const INIT_DELETE_RCV_INFO_ALL_RESP = 'svcMngt/INIT_DELETE_RCV_INFO_ALL_RESP';
const INIT_UPDATE_USAGE_STUS_RESP = 'svcMngt/INIT_UPDATE_USAGE_STUS_RESP';
const INIT_MALL_LIST_RESP = 'svcMngt/INIT_MALL_LIST_RESP';
const INIT_SELECT_FEE_INFO_RESP = 'svcMngt/INIT_SELECT_FEE_INFO_RESP';
const INIT_DOWNLOAD_TUS_CODE_EXCEL_RESP = 'svcMngt/INIT_DOWNLOAD_TUS_CODE_EXCEL_RESP';
const INIT_CHK_OVERLAP_VAN_ID_RESP = 'svcMngt/INIT_CHK_OVERLAP_VAN_ID_RESP';

// U015. 서비스 이용현황 조회
const GET_USAGE_STATUS_LIST = 'svcMngt/GET_USAGE_STATUS_LIST';
const GET_USAGE_STATUS_LIST_SUCCESS = 'svcMngt/GET_USAGE_STATUS_LIST_SUCCESS';
const GET_USAGE_STATUS_LIST_FAILURE = 'svcMngt/GET_USAGE_STATUS_LIST_FAILURE';
// U016. 이용 서비스 신청하기
const INSERT_USAGE_STUS = 'svcMngt/INSERT_USAGE_STUS';
const INSERT_USAGE_STUS_SUCCESS = 'svcMngt/INSERT_USAGE_STUS_SUCCESS';
const INSERT_USAGE_STUS_FAILURE = 'svcMngt/INSERT_USAGE_STUS_FAILURE';
// U017. 서비스 신청된 리스트 사이드 조회
const GET_USAGE_SIDE_LIST = 'svcMngt/GET_USAGE_SIDE_LIST';
const GET_USAGE_SIDE_LIST_SUCCESS = 'svcMngt/GET_USAGE_SIDE_LIST_SUCCESS';
const GET_USAGE_SIDE_LIST_FAILURE = 'svcMngt/GET_USAGE_SIDE_LIST_FAILURE';
// U018. 이용 서비스 임시저장
const INSERT_ACNT_USAGE_INFO = 'svcMngt/INSERT_ACNT_USAGE_INFO';
const INSERT_ACNT_USAGE_INFO_SUCCESS = 'svcMngt/INSERT_ACNT_USAGE_INFO_SUCCESS';
const INSERT_ACNT_USAGE_INFO_FAILURE = 'svcMngt/INSERT_ACNT_USAGE_INFO_FAILURE';
// U019.  이용서비스 접수
const UPDATE_RCPT_INFO = 'svcMngt/UPDATE_RCPT_INFO';
const UPDATE_RCPT_INFO_SUCCESS = 'svcMngt/UPDATE_RCPT_INFO_SUCCESS';
const UPDATE_RCPT_INFO_FAILURE = 'svcMngt/UPDATE_RCPT_INFO_FAILURE';
// U020. 업체 서비스 상세 조회
const GET_USAGE_DETAIL_INFO = 'svcMngt/GET_USAGE_DETAIL_INFO';
const GET_USAGE_DETAIL_INFO_SUCCESS = 'svcMngt/GET_USAGE_DETAIL_INFO_SUCCESS';
const GET_USAGE_DETAIL_INFO_FAILURE = 'svcMngt/GET_USAGE_DETAIL_INFO_FAILURE';
// U021. 이용서비스 수정버튼 클릭시 (이용서비스 변경 및 수정에서 저장)
const SAVE_ACNT_USAGE_INFO = 'svcMngt/SAVE_ACNT_USAGE_INFO';
const SAVE_ACNT_USAGE_INFO_SUCCESS = 'svcMngt/SAVE_ACNT_USAGE_INFO_SUCCESS';
const SAVE_ACNT_USAGE_INFO_FAILURE = 'svcMngt/SAVE_ACNT_USAGE_INFO_FAILURE';
// U022. 해지,이용중지
const INSERT_RCPT_STOP_INFO = 'svcMngt/INSERT_RCPT_STOP_INFO';
const INSERT_RCPT_STOP_INFO_SUCCESS = 'svcMngt/INSERT_RCPT_STOP_INFO_SUCCESS';
const INSERT_RCPT_STOP_INFO_FAILURE = 'svcMngt/INSERT_RCPT_STOP_INFO_FAILURE';
// U023. 서비스 변경 요청
const INSERT_TRANS_STUS_INFO = 'svcMngt/INSERT_TRANS_STUS_INFO';
const INSERT_TRANS_STUS_INFO_SUCCESS = 'svcMngt/INSERT_TRANS_STUS_INFO_SUCCESS';
const INSERT_TRANS_STUS_INFO_FAILURE = 'svcMngt/INSERT_TRANS_STUS_INFO_FAILURE';
// U024. 업체 서비스 신청 상태코드 조회(목록화면 검색조건)
const GET_USAGE_CODE_LIST = 'svcMngt/GET_USAGE_CODE_LIST';
const GET_USAGE_CODE_LIST_SUCCESS = 'svcMngt/GET_USAGE_CODE_LIST_SUCCESS';
const GET_USAGE_CODE_LIST_FAILURE = 'svcMngt/GET_USAGE_CODE_LIST_FAILURE';
// U025. 신청 취소
const UPDATE_CANCEL_RCPT = 'svcMngt/UPDATE_CANCEL_RCPT';
const UPDATE_CANCEL_RCPT_SUCCESS = 'svcMngt/UPDATE_CANCEL_RCPT_SUCCESS';
const UPDATE_CANCEL_RCPT_FAILURE = 'svcMngt/UPDATE_CANCEL_RCPT_FAILURE';
// U026. 해당업체의 문서 코드 조회 (등록 수정 화면에서 사용)
const GET_DOC_USE_LIST = 'svcMngt/GET_DOC_USE_LIST';
const GET_DOC_USE_LIST_SUCCESS = 'svcMngt/GET_DOC_USE_LIST_SUCCESS';
const GET_DOC_USE_LIST_FAILURE = 'svcMngt/GET_DOC_USE_LIST_FAILURE';
// U027. 서비스 신청 그룹 목록 조회
const GET_USAGE_LIST = 'svcMngt/GET_USAGE_LIST';
const GET_USAGE_LIST_SUCCESS = 'svcMngt/GET_USAGE_LIST_SUCCESS';
const GET_USAGE_LIST_FAILURE = 'svcMngt/GET_USAGE_LIST_FAILURE';
// U027. 서비스 신청 그룹 목록 엑셀다운로드
const EXCEL_USAGE_LIST = 'svcMngt/EXCEL_USAGE_LIST';
const EXCEL_USAGE_LIST_SUCCESS = 'svcMngt/EXCEL_USAGE_LIST_SUCCESS';
const EXCEL_USAGE_LIST_FAILURE = 'svcMngt/EXCEL_USAGE_LIST_FAILURE';
// U028. ADMIN 처리내역 수정
const INSERT_PRCS_INFO = 'svcMngt/INSERT_PRCS_INFO';
const INSERT_PRCS_INFO_SUCCESS = 'svcMngt/INSERT_PRCS_INFO_SUCCESS';
const INSERT_PRCS_INFO_FAILURE = 'svcMngt/INSERT_PRCS_INFO_FAILURE';
// U029. 이용현황 조회(ADMIN)
const GET_ADMIN_USE_LIST = 'svcMngt/GET_ADMIN_USE_LIST';
const GET_ADMIN_USE_LIST_SUCCESS = 'svcMngt/GET_ADMIN_USE_LIST_SUCCESS';
const GET_ADMIN_USE_LIST_FAILURE = 'svcMngt/GET_ADMIN_USE_LIST_FAILURE';
// U030. ADMIN 목록에서 처리완료,접수 취소
const INSERT_LIST_PRCS_INFO = 'svcMngt/INSERT_LIST_PRCS_INFO';
const INSERT_LIST_PRCS_INFO_SUCCESS = 'svcMngt/INSERT_LIST_PRCS_INFO_SUCCESS';
const INSERT_LIST_PRCS_INFO_FAILURE = 'svcMngt/INSERT_LIST_PRCS_INFO_FAILURE';
// U049. 수신자 그룹등록
const INSERT_RCV_GROUP_INFO = 'svcMngt/INSERT_RCV_GROUP_INFO';
const INSERT_RCV_GROUP_INFO_SUCCESS = 'svcMngt/INSERT_RCV_GROUP_INFO_SUCCESS';
const INSERT_RCV_GROUP_INFO_FAILURE = 'svcMngt/INSERT_RCV_GROUP_INFO_FAILURE';
// U050. 수신자 목록 조회 상세도 활용 등록화면서도 활용
const GET_RECV_LIST = 'svcMngt/GET_RECV_LIST';
const GET_RECV_LIST_SUCCESS = 'svcMngt/GET_RECV_LIST_SUCCESS';
const GET_RECV_LIST_FAILURE = 'svcMngt/GET_RECV_LIST_FAILURE';
// U051. 등록된 그룹목록조회
const GET_REV_GROUP_LIST = 'svcMngt/GET_REV_GROUP_LIST';
const GET_REV_GROUP_LIST_SUCCESS = 'svcMngt/GET_REV_GROUP_LIST_SUCCESS';
const GET_REV_GROUP_LIST_FAILURE = 'svcMngt/GET_REV_GROUP_LIST_FAILURE';
// 수신자 목록 check local에서 변경
const CHANGE_RECV_CHECK = 'svcMngt/CHANGE_RECV_CHECK';
const CHANGE_RECV_UNCHECK = 'svcMngt/CHANGE_RECV_UNCHECK';
// 처리현황 목록 check local에서 변경
const CHANGE_PRCS_CHECK = 'svcMngt/CHANGE_PRCS_CHECK';
const CHANGE_PRCS_UNCHECK = 'svcMngt/CHANGE_PRCS_UNCHECK';
// U052. 알람서비스 검색조건 그룹 목록 콤보박스
const GET_GRP_NM_LIST = 'svcMngt/GET_GRP_NM_LIST';
const GET_GRP_NM_LIST_SUCCESS = 'svcMngt/GET_GRP_NM_LIST_SUCCESS';
const GET_GRP_NM_LIST_FAILURE = 'svcMngt/GET_GRP_NM_LIST_FAILURE';
// U053. 수신자 그룹수정
const SAVE_RCV_GROUP_INFO = 'svcMngt/SAVE_RCV_GROUP_INFO';
const SAVE_RCV_GROUP_INFO_SUCCESS = 'svcMngt/SAVE_RCV_GROUP_INFO_SUCCESS';
const SAVE_RCV_GROUP_INFO_FAILURE = 'svcMngt/SAVE_RCV_GROUP_INFO_FAILURE';
// U054. 수신자 그룹삭제
const DELETE_RCV_GROUP_INFO = 'svcMngt/DELETE_RCV_GROUP_INFO';
const DELETE_RCV_GROUP_INFO_SUCCESS = 'svcMngt/DELETE_RCV_GROUP_INFO_SUCCESS';
const DELETE_RCV_GROUP_INFO_FAILURE = 'svcMngt/DELETE_RCV_GROUP_INFO_FAILURE';
// U055. 알람서비스 알림업무 콤보 리스트
const GET_SYS_MLIST = 'svcMngt/GET_SYS_MLIST';
const GET_SYS_MLIST_SUCCESS = 'svcMngt/GET_SYS_MLIST_SUCCESS';
const GET_SYS_MLIST_FAILURE = 'svcMngt/GET_SYS_MLIST_FAILURE';
// U057. 상품코드 목록 조회
const GET_TUS_CODE_L = 'svcMngt/GET_TUS_CODE_L';
const GET_TUS_CODE_L_SUCCESS = 'svcMngt/GET_TUS_CODE_L_SUCCESS';
const GET_TUS_CODE_L_FAILURE = 'svcMngt/GET_TUS_CODE_L_FAILURE';
//U2604. 상품코드 엑셀 다운로드
const DOWNLOAD_TUS_CODE_EXCEL = 'svcMngt/DOWNLOAD_TUS_CODE_EXCEL';
const DOWNLOAD_TUS_CODE_EXCEL_SUCCESS = 'svcMngt/DOWNLOAD_TUS_CODE_EXCEL_SUCCESS';
const DOWNLOAD_TUS_CODE_EXCEL_FAILURE = 'svcMngt/DOWNLOAD_TUS_CODE_EXCEL_FAILURE';
// U058. 상품코드 상세 조회
const GET_TUS_CODE_L_DETAIL = 'svcMngt/GET_TUS_CODE_L_DETAIL';
const GET_TUS_CODE_L_DETAIL_SUCCESS = 'svcMngt/GET_TUS_CODE_L_DETAIL_SUCCESS';
const GET_TUS_CODE_L_DETAIL_FAILURE = 'svcMngt/GET_TUS_CODE_L_DETAIL_FAILURE';
// U059. 코드타입, 유통코드 조회
const GET_DSBTR_LIST = 'svcMngt/GET_DSBTR_LIST';
const GET_DSBTR_LIST_SUCCESS = 'svcMngt/GET_DSBTR_LIST_SUCCESS';
const GET_DSBTR_LIST_FAILURE = 'svcMngt/GET_DSBTR_LIST_FAILURE';
// U060. 상품코드 삭제
const DELETE_TUS_CODE_L = 'svcMngt/DELETE_TUS_CODE_L';
const DELETE_TUS_CODE_L_SUCCESS = 'svcMngt/DELETE_TUS_CODE_L_SUCCESS';
const DELETE_TUS_CODE_L_FAILURE = 'svcMngt/DELETE_TUS_CODE_L_FAILURE';
// U061. 상품코드 수정
const UPDATE_TUS_CODE_L = 'svcMngt/UPDATE_TUS_CODE_L';
const UPDATE_TUS_CODE_L_SUCCESS = 'svcMngt/UPDATE_TUS_CODE_L_SUCCESS';
const UPDATE_TUS_CODE_L_FAILURE = 'svcMngt/UPDATE_TUS_CODE_L_FAILURE';
// U062. 상품코드 다건등록
const INSERT_TUS_CODE_EXCEL = 'svcMngt/INSERT_TUS_CODE_EXCEL';
const INSERT_TUS_CODE_EXCEL_SUCCESS = 'svcMngt/INSERT_TUS_CODE_EXCEL_SUCCESS';
const INSERT_TUS_CODE_EXCEL_FAILURE = 'svcMngt/INSERT_TUS_CODE_EXCEL_FAILURE';
// U063. 상품코드 등록
const INSERT_TUS_CODE_L = 'svcMngt/INSERT_TUS_CODE_L';
const INSERT_TUS_CODE_L_SUCCESS = 'svcMngt/INSERT_TUS_CODE_L_SUCCESS';
const INSERT_TUS_CODE_L_FAILURE = 'svcMngt/INSERT_TUS_CODE_L_FAILURE';
// U064. Excell 파일 데이터 검수
const CHECK_EXCEL_FILE = 'svcMngt/CHECK_EXCEL_FILE';
const CHECK_EXCEL_FILE_SUCCESS = 'svcMngt/CHECK_EXCEL_FILE_SUCCESS';
const CHECK_EXCEL_FILE_FAILURE = 'svcMngt/CHECK_EXCEL_FILE_FAILURE';
/// U065. 알람서비스 2번쨰탭 수신자 삭제(수정화면에서)
const DELETE_RCV_INFO = 'svcMngt/DELETE_RCV_INFO';
const DELETE_RCV_INFO_SUCCESS = 'svcMngt/DELETE_RCV_INFO_SUCCESS';
const DELETE_RCV_INFO_FAILURE = 'svcMngt/DELETE_RCV_INFO_FAILURE';
// U068. 알람서비스 3번쨰탭 알림설정등록
const INSERT_ALARM_MNGT = 'svcMngt/INSERT_ALARM_MNGT';
const INSERT_ALARM_MNGT_SUCCESS = 'svcMngt/INSERT_ALARM_MNGT_SUCCESS';
const INSERT_ALARM_MNGT_FAILURE = 'svcMngt/INSERT_ALARM_MNGT_FAILURE';
// U069. 알람서비스 3번쨰탭 알림관리 상세 조회
const GET_ALARM_DETAIL = 'svcMngt/GET_ALARM_DETAIL';
const GET_ALARM_DETAIL_SUCCESS = 'svcMngt/GET_ALARM_DETAIL_SUCCESS';
const GET_ALARM_DETAIL_FAILURE = 'svcMngt/GET_ALARM_DETAIL_FAILURE';
// U070. 알람서비스 3번쨰탭 알림설정수정
const SAVE_ALARM_MNGT = 'svcMngt/SAVE_ALARM_MNGT';
const SAVE_ALARM_MNGT_SUCCESS = 'svcMngt/SAVE_ALARM_MNGT_SUCCESS';
const SAVE_ALARM_MNGT_FAILURE = 'svcMngt/SAVE_ALARM_MNGT_FAILURE';
// U071. 알람서비스 3번쨰탭 알람 삭제
const DELETE_NTCN_INFO = 'svcMngt/DELETE_NTCN_INFO';
const DELETE_NTCN_INFO_SUCCESS = 'svcMngt/DELETE_NTCN_INFO_SUCCESS';
const DELETE_NTCN_INFO_FAILURE = 'svcMngt/DELETE_NTCN_INFO_FAILURE';
// U072. 알람서비스 3번쨰탭 알림관리 목록조회
const GET_NTCN_LIST = 'svcMngt/GET_NTCN_LIST';
const GET_NTCN_LIST_SUCCESS = 'svcMngt/GET_NTCN_LIST_SUCCESS';
const GET_NTCN_LIST_FAILURE = 'svcMngt/GET_NTCN_LIST_FAILURE';
// U079. 알람서비스 알람 상세에서 삭제시 모두삭제
const DELETE_RCV_INFO_ALL = 'svcMngt/DELETE_RCV_INFO_ALL';
const DELETE_RCV_INFO_ALL_SUCCESS = 'svcMngt/DELETE_RCV_INFO_ALL_SUCCESS';
const DELETE_RCV_INFO_ALL_FAILURE = 'svcMngt/DELETE_RCV_INFO_ALL_FAILURE';
// U080. 서비스 변경 시, 그룹코드 생성 및 서비스데이터 복사 저장 - 접수 X
const UPDATE_USAGE_STUS = 'svcMngt/UPDATE_USAGE_STUS';
const UPDATE_USAGE_STUS_SUCCESS = 'svcMngt/UPDATE_USAGE_STUS_SUCCESS';
const UPDATE_USAGE_STUS_FAILURE = 'svcMngt/UPDATE_USAGE_STUS_FAILURE';
// U081. 온라인 연계 몰 리스트
const GET_MALL_LIST = 'svcMngt/GET_MALL_LIST';
const GET_MALL_LIST_SUCCESS = 'svcMngt/GET_MALL_LIST_SUCCESS';
const GET_MALL_LIST_FAILURE = 'svcMngt/GET_MALL_LIST_FAILURE';
// U024. 서비스관리 이용현황 이용중인 요금제 보기
const SELECT_FEE_INFO = 'svcMngt/SELECT_FEE_INFO';
const SELECT_FEE_INFO_SUCCESS = 'svcMngt/SELECT_FEE_INFO_SUCCESS';
const SELECT_FEE_INFO_FAILURE = 'svcMngt/SELECT_FEE_INFO_FAILURE';
// U5122. 동일 유통사 내 VanId 중복 체크
const CHK_OVERLAP_VAN_ID = 'svcMngt/CHK_OVERLAP_VAN_ID';
const CHK_OVERLAP_VAN_ID_SUCCESS = 'svcMngt/CHK_OVERLAP_VAN_ID_SUCCESS';
const CHK_OVERLAP_VAN_ID_FAILURE = 'svcMngt/CHK_OVERLAP_VAN_ID_FAILURE';

// 0. Response 초기화
export const initServiceMngtResp = createAction(INIT_SERVICE_MNGT_RESP);
export const initUsageStusListResp = createAction(INIT_USAGE_STATUS_LIST_RESP);
export const initInsertUsageStusResp = createAction(INIT_INSERT_USAGE_STUS_RESP);
export const initUsageSideListResp = createAction(INIT_USAGE_SIDE_LIST_RESP);
export const initInsertAcntUsageInfoResp = createAction(INIT_INSERT_ACNT_USAGE_INFO_RESP);
export const initUpdateRcptInfoResp = createAction(INIT_UPDATE_RCPT_INFO_RESP);
export const initUsageDetailInfoResp = createAction(INIT_USAGE_DETAIL_INFO_RESP);
export const initSaveAcntUsageInfoResp = createAction(INIT_SAVE_ACNT_USAGE_INFO_RESP);
export const initInsertRcptStopInfoResp = createAction(INIT_INSERT_RCPT_STOP_INFO_RESP);
export const initInsertTransStusInfoResp = createAction(INIT_INSERT_TRANS_STUS_INFO_RESP);
export const initUsageCodeListResp = createAction(INIT_USAGE_CODE_LIST_RESP);
export const initUpdateCancelRcptResp = createAction(INIT_UPDATE_CANCEL_RCPT_RESP);
export const initDocUseListResp = createAction(INIT_DOC_USE_LIST_RESP);
export const initUsageListResp = createAction(INIT_USAGE_LIST_RESP);
export const initExcelUsageListResp = createAction(INIT_EXCEL_USAGE_LIST_RESP);
export const initInsertPrcsInfoResp = createAction(INIT_INSERT_PRCS_INFO_RESP);
export const initAdminUseListResp = createAction(INIT_ADMIN_USE_LIST_RESP);
export const initInsertListPrcsInfoResp = createAction(INIT_INSERT_LIST_PRCS_INFO_RESP);
export const initInsertRcvGroupInfoResp = createAction(INIT_INSERT_RCV_GROUP_INFO_RESP);
export const initRecvListResp = createAction(INIT_RECV_LIST_RESP);
export const initRevGroupListResp = createAction(INIT_REV_GROUP_LIST_RESP);
export const initGrpNmListResp = createAction(INIT_GRP_NM_LIST_RESP);
export const initSaveRcvGroupInfoResp = createAction(INIT_SAVE_RCV_GROUP_INFO_RESP);
export const initDeleteRcvGroupInfoResp = createAction(INIT_DELETE_RCV_GROUP_INFO_RESP);
export const initSysMlistResp = createAction(INIT_SYS_MLIST_RESP);
export const initDeleteRcvInfoAllResp = createAction(INIT_DELETE_RCV_INFO_ALL_RESP);
export const initTusCodeLResp = createAction(INIT_TUS_CODE_L_RESP);
export const initTusCodeLDetailResp = createAction(INIT_TUS_CODE_L_DETAIL_RESP);
export const initDsbtrListResp = createAction(INIT_DSBTR_LIST_RESP);
export const initDeleteTusCodeLResp = createAction(INIT_DELETE_TUS_CODE_L_RESP);
export const initUpdateTusCodeLResp = createAction(INIT_UPDATE_TUS_CODE_L_RESP);
export const initInsertTusCodeExcelResp = createAction(INIT_INSERT_TUS_CODE_EXCEL_RESP);
export const initInsertTusCodeLResp = createAction(INIT_INSERT_TUS_CODE_L_RESP);
export const initCheckExcelFileResp = createAction(INIT_CHECK_EXCEL_FILE_RESP);
export const initDeleteRcvInfoResp = createAction(INIT_DELETE_RCV_INFO_RESP);
export const initInsertAlarmMngtResp = createAction(INIT_INSERT_ALARM_MNGT_RESP);
export const initAlramDetailResp = createAction(INIT_ALARM_DETAIL_RESP);
export const initSaveAlramMngtResp = createAction(INIT_SAVE_ALARM_MNGT_RESP);
export const initDeleteNtcnInfoResp = createAction(INIT_DELETE_NTCN_INFO_RESP);
export const initNtcnListResp = createAction(INIT_NTCN_LIST_RESP);
export const initUpdateUsageStusResp = createAction(INIT_UPDATE_USAGE_STUS_RESP);
export const initMallListResp = createAction(INIT_MALL_LIST_RESP);
export const initDownloadTusCodeExcelResp = createAction(INIT_DOWNLOAD_TUS_CODE_EXCEL_RESP);
export const initSelectFeeInfoResp = createAction(INIT_SELECT_FEE_INFO_RESP);
export const initChkOverLapVanIdResp = createAction(INIT_CHK_OVERLAP_VAN_ID_RESP);

// U015. 서비스 이용현황 조회
export const getUsageStusList = createAction(GET_USAGE_STATUS_LIST, (reqParam) => reqParam);
// U016. 이용 서비스 신청하기
export const insertUsageStus = createAction(INSERT_USAGE_STUS, (dataParam) => dataParam);
// U017. 서비스 신청된 리스트 사이드 조회
export const getUsageSideList = createAction(GET_USAGE_SIDE_LIST, (reqParam) => reqParam);
// U018. 이용 서비스 임시저장
export const insertAcntUsageInfo = createAction(INSERT_ACNT_USAGE_INFO, (dataParam) => dataParam);
// U019.  이용서비스 접수
export const updateRcptInfo = createAction(UPDATE_RCPT_INFO, (dataParam) => dataParam);
// U020. 업체 서비스 상세 조회
export const getUsageDetailInfo = createAction(GET_USAGE_DETAIL_INFO, (reqParam) => reqParam);
// U021. 이용서비스 수정버튼 클릭시 (이용서비스 변경 및 수정에서 저장)
export const saveAcntUsageInfo = createAction(SAVE_ACNT_USAGE_INFO, (dataParam) => dataParam);
// U022. 해지,이용중지
export const insertRcptStopInfo = createAction(INSERT_RCPT_STOP_INFO, (dataParam) => dataParam);
// U023. 서비스 변경 요청
export const insertTransStusInfo = createAction(INSERT_TRANS_STUS_INFO, (dataParam) => dataParam);
// U024. 업체 서비스 신청 상태코드 조회(목록화면 검색조건)
export const getUsageCodeList = createAction(GET_USAGE_CODE_LIST, (reqParam) => reqParam);
// U025. 신청 취소
export const updateCancelRcpt = createAction(UPDATE_CANCEL_RCPT, (rcptGroupSeq) => rcptGroupSeq);
// U026. 해당업체의 문서 코드 조회 (등록 수정 화면에서 사용)
export const getDocUseList = createAction(GET_DOC_USE_LIST, (reqParam) => reqParam);
// U027. 서비스 신청 그룹 목록 조회
export const getUsageList = createAction(GET_USAGE_LIST, (reqParam) => reqParam);
// U027. 서비스 신청 그룹 목록 조회
export const excelUsageList = createAction(EXCEL_USAGE_LIST, (reqParam) => reqParam);
// U028. ADMIN 처리내역 수정
export const insertPrcsInfo = createAction(INSERT_PRCS_INFO, (dataParam) => dataParam);
// U029. 이용현황 조회(ADMIN)
export const getAdminUseList = createAction(GET_ADMIN_USE_LIST, (reqParam) => reqParam);
// U030. ADMIN 목록에서 처리완료,접수 취소
export const insertListPrcsInfo = createAction(INSERT_LIST_PRCS_INFO, (dataParam) => dataParam);
// U049. 수신자 그룹등록
export const insertRcvGroupInfo = createAction(INSERT_RCV_GROUP_INFO, (dataParam) => dataParam);
// U050. 수신자 목록 조회 상세도 활용 등록화면서도 활용
export const getRecvList = createAction(GET_RECV_LIST, (reqParam) => reqParam);
// 수신자 목록 local에서 check 변경
export const changeRecvChk = createAction(CHANGE_RECV_CHECK, (dataParam) => dataParam);
export const changeRecvUnChk = createAction(CHANGE_RECV_UNCHECK, (dataParam) => dataParam);
// 처리현황 목록 local에서 check 변경
export const changePrcsChk = createAction(CHANGE_PRCS_CHECK, (dataParam) => dataParam);
export const changePrcsUnChk = createAction(CHANGE_PRCS_UNCHECK, (dataParam) => dataParam);
// U051. 등록된 그룹목록조회
export const getRevGroupList = createAction(GET_REV_GROUP_LIST, (reqParam) => reqParam);
// U052. 알람서비스 검색조건 그룹 목록 콤보박스
export const getGrpNmList = createAction(GET_GRP_NM_LIST);
// U053. 수신자 그룹수정
export const saveRcvGroupInfo = createAction(SAVE_RCV_GROUP_INFO, (dataParam) => dataParam);
// U054. 수신자 그룹삭제
export const deleteRcvGroupInfo = createAction(DELETE_RCV_GROUP_INFO, (dataParam) => dataParam);
// U055. 알람서비스 알림업무 콤보 리스트
export const getSysMlist = createAction(GET_SYS_MLIST);
// U057. 상품코드 목록 조회
export const getTusCodeL = createAction(GET_TUS_CODE_L, (reqParam) => reqParam);
//U2604. 상품코드 엑셀 다운로드
export const downloadTusCodeExcel = createAction(DOWNLOAD_TUS_CODE_EXCEL, (reqParam) => reqParam);
// U058. 상품코드 상세 조회
export const getTusCodeLDetail = createAction(GET_TUS_CODE_L_DETAIL, (reqParam) => reqParam);
// U059. 코드타입, 유통코드 조회
export const getDsbtrList = createAction(GET_DSBTR_LIST, (reqParam) => reqParam);
// U060. 상품코드 삭제
export const deleteTusCodeL = createAction(DELETE_TUS_CODE_L, (dataParam) => dataParam);
// U061. 상품코드 수정
export const updateTusCodeL = createAction(UPDATE_TUS_CODE_L, (dataParam) => dataParam);
// U062. 상품코드 다건등록
export const insertTusCodeExcel = createAction(INSERT_TUS_CODE_EXCEL, (dataParam) => dataParam);
// U063. 상품코드 등록
export const insertTusCodeL = createAction(INSERT_TUS_CODE_L, (dataParam) => dataParam);
// U064. Excell 파일 데이터 검수
export const checkExcelFile = createAction(CHECK_EXCEL_FILE, (file) => file);
// U065. 알람서비스 2번쨰탭 수신자 삭제(수정화면에서)
export const deleteRcvInfo = createAction(DELETE_RCV_INFO, (dataParam) => dataParam);
// U068. 알람서비스 3번쨰탭 알림설정등록
export const insertAlarmMngt = createAction(INSERT_ALARM_MNGT, (dataParam) => dataParam);
// U069. 알람서비스 3번쨰탭 알림관리 상세 조회
export const getAlramDetail = createAction(GET_ALARM_DETAIL, (ntcnCode) => ntcnCode);
// U070. 알람서비스 3번쨰탭 알림설정수정
export const saveAlramMngt = createAction(SAVE_ALARM_MNGT, (dataParam) => dataParam);
// U071. 알람서비스 3번쨰탭 알람 삭제
export const deleteNtcnInfo = createAction(DELETE_NTCN_INFO, (dataParam) => dataParam);
// U072. 알람서비스 3번쨰탭 알림관리 목록조회
export const getNtcnList = createAction(GET_NTCN_LIST, (reqParam) => reqParam);
// U079. 알람 서비스 알람 상세에서 삭제시 모두 삭제
export const deleteRcvInfoAll = createAction(DELETE_RCV_INFO_ALL, (reqParam) => reqParam);
// U080. 서비스 변경 시, 그룹코드 생성 및 서비스데이터 복사 저장 - 접수 X
export const updateUsageStus = createAction(UPDATE_USAGE_STUS, (rcptSeq) => rcptSeq);
// U081. 온라인 연계 몰 리스트
export const getMallList = createAction(GET_MALL_LIST, (dsrbtrCode) => dsrbtrCode);
// U024. 서비스관리 이용현황 이용중인 요금제 보기
export const selectFeeInfo = createAction(SELECT_FEE_INFO);
// U5122. 동일 유통사 내 VanId 중복 체크
export const chkOverLapVanId = createAction(CHK_OVERLAP_VAN_ID);

const getUsageStusListSaga = createRequestSaga(GET_USAGE_STATUS_LIST, apiSvcMngt.getUsageStusList);
const insertUsageStusSaga = createRequestSaga(INSERT_USAGE_STUS, apiSvcMngt.insertUsageStus);
const getUsageSideListSaga = createRequestSaga(GET_USAGE_SIDE_LIST, apiSvcMngt.getUsageSideList);
const insertAcntUsageInfoSaga = createRequestSaga(INSERT_ACNT_USAGE_INFO, apiSvcMngt.insertAcntUsageInfo);
const updateRcptInfoSaga = createRequestSaga(UPDATE_RCPT_INFO, apiSvcMngt.updateRcptInfo);
const getUsageDetailInfoSaga = createRequestSaga(GET_USAGE_DETAIL_INFO, apiSvcMngt.getUsageDetailInfo);
const saveAcntUsageInfoSaga = createRequestSaga(SAVE_ACNT_USAGE_INFO, apiSvcMngt.saveAcntUsageInfo);
const insertRcptStopInfoSaga = createRequestSaga(INSERT_RCPT_STOP_INFO, apiSvcMngt.insertRcptStopInfo);
const insertTransStusInfoSaga = createRequestSaga(INSERT_TRANS_STUS_INFO, apiSvcMngt.insertTransStusInfo);
const getUsageCodeListSaga = createRequestSaga(GET_USAGE_CODE_LIST, apiSvcMngt.getUsageCodeList);
const updateCancelRcptSaga = createRequestSaga(UPDATE_CANCEL_RCPT, apiSvcMngt.updateCancelRcpt);
const getDocUseListSaga = createRequestSaga(GET_DOC_USE_LIST, apiSvcMngt.getDocUseList);
const getUsageListSaga = createRequestSaga(GET_USAGE_LIST, apiSvcMngt.getUsageList);
const excelUsageListSaga = createRequestSaga(EXCEL_USAGE_LIST, apiSvcMngt.excelUsageList);
const insertPrcsInfoSaga = createRequestSaga(INSERT_PRCS_INFO, apiSvcMngt.insertPrcsInfo);
const getAdminUseListSaga = createRequestSaga(GET_ADMIN_USE_LIST, apiSvcMngt.getAdminUseList);
const insertListPrcsInfoSaga = createRequestSaga(INSERT_LIST_PRCS_INFO, apiSvcMngt.insertListPrcsInfo);
const insertRcvGroupInfoSaga = createRequestSaga(INSERT_RCV_GROUP_INFO, apiSvcMngt.insertRcvGroupInfo);
const getRecvListSaga = createRequestSaga(GET_RECV_LIST, apiSvcMngt.getRecvList);
const getRevGroupListSaga = createRequestSaga(GET_REV_GROUP_LIST, apiSvcMngt.getRevGroupList);
const getGrpNmListSaga = createRequestSaga(GET_GRP_NM_LIST, apiSvcMngt.getGrpNmList);
const saveRcvGroupInfoSaga = createRequestSaga(SAVE_RCV_GROUP_INFO, apiSvcMngt.saveRcvGroupInfo);
const deleteRcvGroupInfoSaga = createRequestSaga(DELETE_RCV_GROUP_INFO, apiSvcMngt.deleteRcvGroupInfo);
const getSysMlistSaga = createRequestSaga(GET_SYS_MLIST, apiSvcMngt.getSysMlist);
const getTusCodeLSaga = createRequestSaga(GET_TUS_CODE_L, apiSvcMngt.getTusCodeL);
const getTusCodeLDetailSaga = createRequestSaga(GET_TUS_CODE_L_DETAIL, apiSvcMngt.getTusCodeLDetail);
const getDsbtrListSaga = createRequestSaga(GET_DSBTR_LIST, apiSvcMngt.getDsbtrList);
const deleteTusCodeLSaga = createRequestSaga(DELETE_TUS_CODE_L, apiSvcMngt.deleteTusCodeL);
const updateTusCodeLSaga = createRequestSaga(UPDATE_TUS_CODE_L, apiSvcMngt.updateTusCodeL);
const insertTusCodeExcelSaga = createRequestSaga(INSERT_TUS_CODE_EXCEL, apiSvcMngt.insertTusCodeExcel);
const insertTusCodeLSaga = createRequestSaga(INSERT_TUS_CODE_L, apiSvcMngt.insertTusCodeL);
const checkExcelFileSaga = createRequestSaga(CHECK_EXCEL_FILE, apiSvcMngt.checkExcelFile);
const deleteRcvInfoSaga = createRequestSaga(DELETE_RCV_INFO, apiSvcMngt.deleteRcvInfo);
const insertAlarmMngtSaga = createRequestSaga(INSERT_ALARM_MNGT, apiSvcMngt.insertAlarmMngt);
const getAlramDetailSaga = createRequestSaga(GET_ALARM_DETAIL, apiSvcMngt.getAlramDetail);
const saveAlramMngtSaga = createRequestSaga(SAVE_ALARM_MNGT, apiSvcMngt.saveAlramMngt);
const deleteNtcnInfoSaga = createRequestSaga(DELETE_NTCN_INFO, apiSvcMngt.deleteNtcnInfo);
const getNtcnListSaga = createRequestSaga(GET_NTCN_LIST, apiSvcMngt.getNtcnList);
const deleteRcvInfoAllSaga = createRequestSaga(DELETE_RCV_INFO_ALL, apiSvcMngt.deleteRcvInfoAll);
const updateUsageStusSaga = createRequestSaga(UPDATE_USAGE_STUS, apiSvcMngt.updateUsageStus);
const getMallListSaga = createRequestSaga(GET_MALL_LIST, apiSvcMngt.getMallList);
const downloadTusCodeExcelSaga = createRequestSaga(DOWNLOAD_TUS_CODE_EXCEL, apiSvcMngt.downloadTusCodeExcel);
const selectFeeInfoSaga = createRequestSaga(SELECT_FEE_INFO, apiSvcMngt.selectFeeInfo);
const chkOverLapVanIdSaga = createRequestSaga(CHK_OVERLAP_VAN_ID, apiSvcMngt.chkOverLapVanId);

// apiServiceMngtSaga
export function* apiServiceMngtSaga() {
  yield takeLatest(GET_USAGE_STATUS_LIST, getUsageStusListSaga);
  yield takeLatest(INSERT_USAGE_STUS, insertUsageStusSaga);
  yield takeLatest(GET_USAGE_SIDE_LIST, getUsageSideListSaga);
  yield takeLatest(INSERT_ACNT_USAGE_INFO, insertAcntUsageInfoSaga);
  yield takeLatest(UPDATE_RCPT_INFO, updateRcptInfoSaga);
  yield takeLatest(GET_USAGE_DETAIL_INFO, getUsageDetailInfoSaga);
  yield takeLatest(SAVE_ACNT_USAGE_INFO, saveAcntUsageInfoSaga);
  yield takeLatest(INSERT_RCPT_STOP_INFO, insertRcptStopInfoSaga);
  yield takeLatest(INSERT_TRANS_STUS_INFO, insertTransStusInfoSaga);
  yield takeLatest(GET_USAGE_CODE_LIST, getUsageCodeListSaga);
  yield takeLatest(UPDATE_CANCEL_RCPT, updateCancelRcptSaga);
  yield takeLatest(GET_DOC_USE_LIST, getDocUseListSaga);
  yield takeLatest(GET_USAGE_LIST, getUsageListSaga);
  yield takeLatest(EXCEL_USAGE_LIST, excelUsageListSaga);
  yield takeLatest(INSERT_PRCS_INFO, insertPrcsInfoSaga);
  yield takeLatest(GET_ADMIN_USE_LIST, getAdminUseListSaga);
  yield takeLatest(INSERT_LIST_PRCS_INFO, insertListPrcsInfoSaga);
  yield takeLatest(INSERT_RCV_GROUP_INFO, insertRcvGroupInfoSaga);
  yield takeLatest(GET_RECV_LIST, getRecvListSaga);
  yield takeLatest(GET_REV_GROUP_LIST, getRevGroupListSaga);
  yield takeLatest(GET_GRP_NM_LIST, getGrpNmListSaga);
  yield takeLatest(SAVE_RCV_GROUP_INFO, saveRcvGroupInfoSaga);
  yield takeLatest(DELETE_RCV_GROUP_INFO, deleteRcvGroupInfoSaga);
  yield takeLatest(GET_SYS_MLIST, getSysMlistSaga);
  yield takeLatest(GET_TUS_CODE_L, getTusCodeLSaga);
  yield takeLatest(GET_TUS_CODE_L_DETAIL, getTusCodeLDetailSaga);
  yield takeLatest(GET_DSBTR_LIST, getDsbtrListSaga);
  yield takeLatest(DELETE_TUS_CODE_L, deleteTusCodeLSaga);
  yield takeLatest(UPDATE_TUS_CODE_L, updateTusCodeLSaga);
  yield takeLatest(INSERT_TUS_CODE_EXCEL, insertTusCodeExcelSaga);
  yield takeLatest(INSERT_TUS_CODE_L, insertTusCodeLSaga);
  yield takeLatest(CHECK_EXCEL_FILE, checkExcelFileSaga);
  yield takeLatest(DELETE_RCV_INFO, deleteRcvInfoSaga);
  yield takeLatest(INSERT_ALARM_MNGT, insertAlarmMngtSaga);
  yield takeLatest(GET_ALARM_DETAIL, getAlramDetailSaga);
  yield takeLatest(SAVE_ALARM_MNGT, saveAlramMngtSaga);
  yield takeLatest(DELETE_NTCN_INFO, deleteNtcnInfoSaga);
  yield takeLatest(GET_NTCN_LIST, getNtcnListSaga);
  yield takeLatest(DELETE_RCV_INFO_ALL, deleteRcvInfoAllSaga);
  yield takeLatest(UPDATE_USAGE_STUS, updateUsageStusSaga);
  yield takeLatest(GET_MALL_LIST, getMallListSaga);
  yield takeLatest(DOWNLOAD_TUS_CODE_EXCEL, downloadTusCodeExcelSaga);
  yield takeLatest(SELECT_FEE_INFO, selectFeeInfoSaga);
  yield takeLatest(CHK_OVERLAP_VAN_ID, chkOverLapVanIdSaga);
}

// 초기 상태를 선언
// 요청의 로딩 중 상태는 loading 객체에서 관리
const initialState = {
  getUsageStusListResp: null,
  insertUsageStusResp: null,
  getUsageSideListResp: null,
  insertAcntUsageInfoResp: null,
  updateRcptInfoResp: null,
  getUsageDetailInfoResp: null,
  saveAcntUsageInfoResp: null,
  insertRcptStopInfoResp: null,
  insertTransStusInfoResp: null,
  getUsageCodeListResp: null,
  updateCancelRcptResp: null,
  getDocUseListResp: null,
  getUsageListResp: null,
  insertPrcsInfoResp: null,
  getAdminUseListResp: null,
  insertListPrcsInfoResp: null,
  insertRcvGroupInfoResp: null,
  getRecvListResp: null,
  getRevGroupListResp: null,
  getGrpNmListResp: null,
  saveRcvGroupInfoResp: null,
  deleteRcvGroupInfoResp: null,
  getSysMlistResp: null,
  getTusCodeLResp: null,
  getTusCodeLDetailResp: null,
  getDsbtrListResp: null,
  deleteTusCodeLResp: null,
  updateTusCodeLResp: null,
  insertTusCodeExcelResp: null,
  insertTusCodeLResp: null,
  checkExcelFileResp: null,
  deleteRcvInfoResp: null,
  insertAlarmMngtResp: null,
  getAlramDetailResp: null,
  saveAlramMngtResp: null,
  deleteNtcnInfoResp: null,
  getNtcnListResp: null,
  deleteRcvInfoAllResp: null,
  updateUsageStusResp: null,
  getMallListResp: null,
  excelUsageListResp: null,
  downloadTusCodeExcelResp: null,
  selectFeeInfoResp: null,
  chkOverLapVanIdResp: null,
};

const apiServiceMngtResp = handleActions(
  {
    // 0. Response 초기화
    [INIT_SERVICE_MNGT_RESP]: (state, action) => ({
      getUsageStusListResp: null,
      insertUsageStusResp: null,
      getUsageSideListResp: null,
      insertAcntUsageInfoResp: null,
      updateRcptInfoResp: null,
      getUsageDetailInfoResp: null,
      saveAcntUsageInfoResp: null,
      insertRcptStopInfoResp: null,
      insertTransStusInfoResp: null,
      getUsageCodeListResp: null,
      updateCancelRcptResp: null,
      getDocUseListResp: null,
      getUsageListResp: null,
      insertPrcsInfoResp: null,
      getAdminUseListResp: null,
      insertListPrcsInfoResp: null,
      insertRcvGroupInfoResp: null,
      getRecvListResp: null,
      getRevGroupListResp: null,
      getGrpNmListResp: null,
      saveRcvGroupInfoResp: null,
      deleteRcvGroupInfoResp: null,
      getSysMlistResp: null,
      getTusCodeLResp: null,
      getTusCodeLDetailResp: null,
      getDsbtrListResp: null,
      deleteTusCodeLResp: null,
      updateTusCodeLResp: null,
      insertTusCodeExcelResp: null,
      insertTusCodeLResp: null,
      checkExcelFileResp: null,
      deleteRcvInfoResp: null,
      insertAlarmMngtResp: null,
      getAlramDetailResp: null,
      saveAlramMngtResp: null,
      deleteNtcnInfoResp: null,
      getNtcnListResp: null,
      deleteRcvInfoAllResp: null,
      updateUsageStusResp: null,
      getMallListResp: null,
      excelUsageListResp: null,
      downloadTusCodeExcelResp: null,
      selectFeeInfoResp: null,
      chkOverLapVanIdResp: null,
    }),
    [INIT_USAGE_STATUS_LIST_RESP]: (state, action) => ({
      ...state,
      getUsageStusListResp: null,
    }),
    [INIT_INSERT_USAGE_STUS_RESP]: (state, action) => ({
      ...state,
      insertUsageStusResp: null,
    }),
    [INIT_USAGE_SIDE_LIST_RESP]: (state, action) => ({
      ...state,
      getUsageSideListResp: null,
    }),
    [INIT_INSERT_ACNT_USAGE_INFO_RESP]: (state, action) => ({
      ...state,
      insertAcntUsageInfoResp: null,
    }),
    [INIT_UPDATE_RCPT_INFO_RESP]: (state, action) => ({
      ...state,
      updateRcptInfoResp: null,
    }),
    [INIT_USAGE_DETAIL_INFO_RESP]: (state, action) => ({
      ...state,
      getUsageDetailInfoResp: null,
    }),
    [INIT_SAVE_ACNT_USAGE_INFO_RESP]: (state, action) => ({
      ...state,
      saveAcntUsageInfoResp: null,
    }),
    [INIT_INSERT_RCPT_STOP_INFO_RESP]: (state, action) => ({
      ...state,
      insertRcptStopInfoResp: null,
    }),
    [INIT_INSERT_TRANS_STUS_INFO_RESP]: (state, action) => ({
      ...state,
      insertTransStusInfoResp: null,
    }),
    [INIT_USAGE_CODE_LIST_RESP]: (state, action) => ({
      ...state,
      getUsageCodeListResp: null,
    }),
    [INIT_UPDATE_CANCEL_RCPT_RESP]: (state, action) => ({
      ...state,
      updateCancelRcptResp: null,
    }),
    [INIT_DOC_USE_LIST_RESP]: (state, action) => ({
      ...state,
      getDocUseListResp: null,
    }),
    [INIT_USAGE_LIST_RESP]: (state, action) => ({
      ...state,
      getUsageListResp: null,
    }),
    [INIT_INSERT_PRCS_INFO_RESP]: (state, action) => ({
      ...state,
      insertPrcsInfoResp: null,
    }),
    [INIT_ADMIN_USE_LIST_RESP]: (state, action) => ({
      ...state,
      getAdminUseListResp: null,
    }),
    [INIT_INSERT_LIST_PRCS_INFO_RESP]: (state, action) => ({
      ...state,
      insertListPrcsInfoResp: null,
    }),
    [INIT_INSERT_RCV_GROUP_INFO_RESP]: (state, action) => ({
      ...state,
      insertRcvGroupInfoResp: null,
    }),
    [INIT_RECV_LIST_RESP]: (state, action) => ({
      ...state,
      getRecvListResp: null,
    }),
    [INIT_REV_GROUP_LIST_RESP]: (state, action) => ({
      ...state,
      getRevGroupListResp: null,
    }),
    [INIT_GRP_NM_LIST_RESP]: (state, action) => ({
      ...state,
      getGrpNmListResp: null,
    }),
    [INIT_SAVE_RCV_GROUP_INFO_RESP]: (state, action) => ({
      ...state,
      saveRcvGroupInfoResp: null,
    }),
    [INIT_DELETE_RCV_GROUP_INFO_RESP]: (state, action) => ({
      ...state,
      deleteRcvGroupInfoResp: null,
    }),
    [INIT_SYS_MLIST_RESP]: (state, action) => ({
      ...state,
      getSysMlistResp: null,
    }),
    [INIT_TUS_CODE_L_RESP]: (state, action) => ({
      ...state,
      getTusCodeLResp: null,
    }),
    [INIT_TUS_CODE_L_DETAIL_RESP]: (state, action) => ({
      ...state,
      getTusCodeLDetailResp: null,
    }),
    [INIT_DSBTR_LIST_RESP]: (state, action) => ({
      ...state,
      getDsbtrListResp: null,
    }),
    [INIT_DELETE_TUS_CODE_L_RESP]: (state, action) => ({
      ...state,
      deleteTusCodeLResp: null,
    }),
    [INIT_UPDATE_TUS_CODE_L_RESP]: (state, action) => ({
      ...state,
      updateTusCodeLResp: null,
    }),
    [INIT_INSERT_TUS_CODE_EXCEL_RESP]: (state, action) => ({
      ...state,
      insertTusCodeExcelResp: null,
    }),
    [INIT_INSERT_TUS_CODE_L_RESP]: (state, action) => ({
      ...state,
      insertTusCodeLResp: null,
    }),
    [INIT_CHECK_EXCEL_FILE_RESP]: (state, action) => ({
      ...state,
      checkExcelFileResp: null,
    }),
    [INIT_DELETE_RCV_INFO_RESP]: (state, action) => ({
      ...state,
      deleteRcvInfoResp: null,
    }),
    [INIT_INSERT_ALARM_MNGT_RESP]: (state, action) => ({
      ...state,
      insertAlarmMngtResp: null,
    }),
    [INIT_ALARM_DETAIL_RESP]: (state, action) => ({
      ...state,
      getAlramDetailResp: null,
    }),
    [INIT_SAVE_ALARM_MNGT_RESP]: (state, action) => ({
      ...state,
      saveAlramMngtResp: null,
    }),
    [INIT_DELETE_NTCN_INFO_RESP]: (state, action) => ({
      ...state,
      deleteNtcnInfoResp: null,
    }),
    [INIT_NTCN_LIST_RESP]: (state, action) => ({
      ...state,
      getNtcnListResp: null,
    }),
    [INIT_DELETE_RCV_INFO_ALL_RESP]: (state, action) => ({
      ...state,
      deleteRcvInfoAllResp: null,
    }),
    [INIT_UPDATE_USAGE_STUS_RESP]: (state, action) => ({
      ...state,
      updateUsageStusResp: null,
    }),
    [INIT_MALL_LIST_RESP]: (state, action) => ({
      ...state,
      getMallListResp: null,
    }),
    [INIT_EXCEL_USAGE_LIST_RESP]: (state, action) => ({
      ...state,
      excelUsageListResp: null,
    }),
    [INIT_DOWNLOAD_TUS_CODE_EXCEL_RESP]: (state, action) => ({
      ...state,
      downloadTusCodeExcelResp: null,
    }),
    [INIT_SELECT_FEE_INFO_RESP]: (state, action) => ({
      ...state,
      selectFeeInfoResp: null,
    }),
    [INIT_CHK_OVERLAP_VAN_ID_RESP]: (state, action) => ({
      ...state,
      chkOverLapVanIdResp: null,
    }),
    // U015. 서비스 이용현황 조회
    [GET_USAGE_STATUS_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getUsageStusListResp: action.payload,
    }),
    [GET_USAGE_STATUS_LIST_FAILURE]: (state, action) => ({
      ...state,
      getUsageStusListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U016. 이용 서비스 신청하기
    [INSERT_USAGE_STUS_SUCCESS]: (state, action) => ({
      ...state,
      insertUsageStusResp: action.payload,
    }),
    [INSERT_USAGE_STUS_FAILURE]: (state, action) => ({
      ...state,
      insertUsageStusResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U017. 서비스 신청된 리스트 사이드 조회
    [GET_USAGE_SIDE_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getUsageSideListResp: action.payload,
    }),
    [GET_USAGE_SIDE_LIST_FAILURE]: (state, action) => ({
      ...state,
      getUsageSideListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U018. 이용 서비스 임시저장
    [INSERT_ACNT_USAGE_INFO_SUCCESS]: (state, action) => ({
      ...state,
      insertAcntUsageInfoResp: action.payload,
    }),
    [INSERT_ACNT_USAGE_INFO_FAILURE]: (state, action) => ({
      ...state,
      insertAcntUsageInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U019.  이용서비스 접수
    [UPDATE_RCPT_INFO_SUCCESS]: (state, action) => ({
      ...state,
      updateRcptInfoResp: action.payload,
    }),
    [UPDATE_RCPT_INFO_FAILURE]: (state, action) => ({
      ...state,
      updateRcptInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U020. 업체 서비스 상세 조회
    [GET_USAGE_DETAIL_INFO_SUCCESS]: (state, action) => ({
      ...state,
      getUsageDetailInfoResp: action.payload,
    }),
    [GET_USAGE_DETAIL_INFO_FAILURE]: (state, action) => ({
      ...state,
      getUsageDetailInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U021. 이용서비스 수정버튼 클릭시 (이용서비스 변경 및 수정에서 저장)
    [SAVE_ACNT_USAGE_INFO_SUCCESS]: (state, action) => ({
      ...state,
      saveAcntUsageInfoResp: action.payload,
    }),
    [SAVE_ACNT_USAGE_INFO_FAILURE]: (state, action) => ({
      ...state,
      saveAcntUsageInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U022. 해지,이용중지
    [INSERT_RCPT_STOP_INFO_SUCCESS]: (state, action) => ({
      ...state,
      insertRcptStopInfoResp: action.payload,
    }),
    [INSERT_RCPT_STOP_INFO_FAILURE]: (state, action) => ({
      ...state,
      insertRcptStopInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U023. 서비스 변경 요청
    [INSERT_TRANS_STUS_INFO_SUCCESS]: (state, action) => ({
      ...state,
      insertTransStusInfoResp: action.payload,
    }),
    [INSERT_TRANS_STUS_INFO_FAILURE]: (state, action) => ({
      ...state,
      insertTransStusInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U024. 업체 서비스 신청 상태코드 조회(목록화면 검색조건)
    [GET_USAGE_CODE_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getUsageCodeListResp: action.payload,
    }),
    [GET_USAGE_CODE_LIST_FAILURE]: (state, action) => ({
      ...state,
      getUsageCodeListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U025. 신청 취소
    [UPDATE_CANCEL_RCPT_SUCCESS]: (state, action) => ({
      ...state,
      updateCancelRcptResp: action.payload,
    }),
    [UPDATE_CANCEL_RCPT_FAILURE]: (state, action) => ({
      ...state,
      updateCancelRcptResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U026. 해당업체의 문서 코드 조회 (등록 수정 화면에서 사용)
    [GET_DOC_USE_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getDocUseListResp: action.payload,
    }),
    [GET_DOC_USE_LIST_FAILURE]: (state, action) => ({
      ...state,
      getDocUseListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U027. 서비스 신청 그룹 목록 조회
    [GET_USAGE_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getUsageListResp: action.payload,
    }),
    [GET_USAGE_LIST_FAILURE]: (state, action) => ({
      ...state,
      getUsageListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U027. 서비스 신청 그룹 목록 엑셀 다운로드
    [EXCEL_USAGE_LIST_SUCCESS]: (state, action) => ({
      ...state,
      excelUsageListResp: { data: action.payload, headers: action.headers },
    }),
    [EXCEL_USAGE_LIST_FAILURE]: (state, action) => ({
      ...state,
      excelUsageListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U028. ADMIN 처리내역 수정
    [INSERT_PRCS_INFO_SUCCESS]: (state, action) => ({
      ...state,
      insertPrcsInfoResp: action.payload,
    }),
    [INSERT_PRCS_INFO_FAILURE]: (state, action) => ({
      ...state,
      insertPrcsInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U029. 이용현황 조회(ADMIN)
    [GET_ADMIN_USE_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getAdminUseListResp: action.payload,
    }),
    [GET_ADMIN_USE_LIST_FAILURE]: (state, action) => ({
      ...state,
      getAdminUseListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U030. ADMIN 목록에서 처리완료,접수 취소
    [INSERT_LIST_PRCS_INFO_SUCCESS]: (state, action) => ({
      ...state,
      insertListPrcsInfoResp: action.payload,
    }),
    [INSERT_LIST_PRCS_INFO_FAILURE]: (state, action) => ({
      ...state,
      insertListPrcsInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U049. 수신자 그룹등록
    [INSERT_RCV_GROUP_INFO_SUCCESS]: (state, action) => ({
      ...state,
      insertRcvGroupInfoResp: action.payload,
    }),
    [INSERT_RCV_GROUP_INFO_FAILURE]: (state, action) => ({
      ...state,
      insertRcvGroupInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U050. 수신자 목록 조회 상세도 활용 등록화면서도 활용
    [GET_RECV_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getRecvListResp: action.payload,
    }),
    [GET_RECV_LIST_FAILURE]: (state, action) => ({
      ...state,
      getRecvListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // 수신자 목록 local에서 chk변경
    [CHANGE_RECV_CHECK]: (state, action) => ({
      ...state,
      getRecvListResp: {
        ...state.getRecvListResp,
        data: state.getRecvListResp.data.map((recv) => {
          if (recv.usId === action.payload) {
            return {
              ...recv,
              chk: '1',
            };
          } else {
            return { ...recv };
          }
        }),
      },
    }),
    [CHANGE_RECV_UNCHECK]: (state, action) => ({
      ...state,
      getRecvListResp: {
        ...state.getRecvListResp,
        data: state.getRecvListResp.data.map((recv) => {
          if (recv.usId === action.payload) {
            return {
              ...recv,
              chk: '0',
            };
          } else {
            return { ...recv };
          }
        }),
      },
    }),
    // 처리현황 목록 local에서 chk변경
    [CHANGE_PRCS_CHECK]: (state, action) => ({
      ...state,
      getUsageListResp: {
        ...state.getUsageListResp,
        DataList: state.getUsageListResp.DataList.map((prcs) => {
          if (prcs.rcptGroupCode === action.payload) {
            return {
              ...prcs,
              chk: true,
            };
          } else {
            return { ...prcs };
          }
        }),
      },
    }),
    [CHANGE_PRCS_UNCHECK]: (state, action) => ({
      ...state,
      getUsageListResp: {
        ...state.getUsageListResp,
        DataList: state.getUsageListResp.DataList.map((prcs) => {
          if (prcs.rcptGroupCode === action.payload) {
            return {
              ...prcs,
              chk: false,
            };
          } else {
            return { ...prcs };
          }
        }),
      },
    }),
    // U051. 등록된 그룹목록조회
    [GET_REV_GROUP_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getRevGroupListResp: action.payload,
    }),
    [GET_REV_GROUP_LIST_FAILURE]: (state, action) => ({
      ...state,
      getRevGroupListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U052. 알람서비스 검색조건 그룹 목록 콤보박스
    [GET_GRP_NM_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getGrpNmListResp: action.payload,
    }),
    [GET_GRP_NM_LIST_FAILURE]: (state, action) => ({
      ...state,
      getGrpNmListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U053. 수신자 그룹수정
    [SAVE_RCV_GROUP_INFO_SUCCESS]: (state, action) => ({
      ...state,
      saveRcvGroupInfoResp: action.payload,
    }),
    [SAVE_RCV_GROUP_INFO_FAILURE]: (state, action) => ({
      ...state,
      saveRcvGroupInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U054. 수신자 그룹삭제
    [DELETE_RCV_GROUP_INFO_SUCCESS]: (state, action) => ({
      ...state,
      deleteRcvGroupInfoResp: action.payload,
    }),
    [DELETE_RCV_GROUP_INFO_FAILURE]: (state, action) => ({
      ...state,
      deleteRcvGroupInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U055. 알람서비스 알림업무 콤보 리스트
    [GET_SYS_MLIST_SUCCESS]: (state, action) => ({
      ...state,
      getSysMlistResp: action.payload,
    }),
    [GET_SYS_MLIST_FAILURE]: (state, action) => ({
      ...state,
      getSysMlisttResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U057. 상품코드 목록 조회
    [GET_TUS_CODE_L_SUCCESS]: (state, action) => ({
      ...state,
      getTusCodeLResp: action.payload,
    }),
    [GET_TUS_CODE_L_FAILURE]: (state, action) => ({
      ...state,
      getTusCodeLResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    //U2604. 상품코드 엑셀 다운로드
    [DOWNLOAD_TUS_CODE_EXCEL_SUCCESS]: (state, action) => ({
      ...state,
      downloadTusCodeExcelResp: { data: action.payload, headers: action.headers },
    }),
    [DOWNLOAD_TUS_CODE_EXCEL_FAILURE]: (state, action) => ({
      ...state,
      downloadTusCodeExcelResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U058. 상품코드 상세 조회
    [GET_TUS_CODE_L_DETAIL_SUCCESS]: (state, action) => ({
      ...state,
      getTusCodeLDetailResp: action.payload,
    }),
    [GET_TUS_CODE_L_DETAIL_FAILURE]: (state, action) => ({
      ...state,
      getTusCodeLDetailResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U059. 코드타입, 유통코드 조회
    [GET_DSBTR_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getDsbtrListResp: action.payload,
    }),
    [GET_DSBTR_LIST_FAILURE]: (state, action) => ({
      ...state,
      getDsbtrListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U060. 상품코드 삭제
    [DELETE_TUS_CODE_L_SUCCESS]: (state, action) => ({
      ...state,
      deleteTusCodeLResp: action.payload,
    }),
    [DELETE_TUS_CODE_L_FAILURE]: (state, action) => ({
      ...state,
      deleteTusCodeLResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U061. 상품코드 수정
    [UPDATE_TUS_CODE_L_SUCCESS]: (state, action) => ({
      ...state,
      updateTusCodeLResp: action.payload,
    }),
    [UPDATE_TUS_CODE_L_FAILURE]: (state, action) => ({
      ...state,
      updateTusCodeLResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U062. 상품코드 다건등록
    [INSERT_TUS_CODE_EXCEL_SUCCESS]: (state, action) => ({
      ...state,
      insertTusCodeExcelResp: action.payload,
    }),
    [INSERT_TUS_CODE_EXCEL_FAILURE]: (state, action) => ({
      ...state,
      insertTusCodeExcelResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U063. 상품코드 등록
    [INSERT_TUS_CODE_L_SUCCESS]: (state, action) => ({
      ...state,
      insertTusCodeLResp: action.payload,
    }),
    [INSERT_TUS_CODE_L_FAILURE]: (state, action) => ({
      ...state,
      insertTusCodeLResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U064. Excell 파일 데이터 검수
    [CHECK_EXCEL_FILE_SUCCESS]: (state, action) => ({
      ...state,
      checkExcelFileResp: action.payload,
    }),
    [CHECK_EXCEL_FILE_FAILURE]: (state, action) => ({
      ...state,
      checkExcelFileResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U065. 알람서비스 2번쨰탭 수신자 삭제(수정화면에서)
    [DELETE_RCV_INFO_SUCCESS]: (state, action) => ({
      ...state,
      deleteRcvInfoResp: action.payload,
    }),
    [DELETE_RCV_INFO_FAILURE]: (state, action) => ({
      ...state,
      deleteRcvInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U068. 알람서비스 3번쨰탭 알림설정등록
    [INSERT_ALARM_MNGT_SUCCESS]: (state, action) => ({
      ...state,
      insertAlarmMngtResp: action.payload,
    }),
    [INSERT_ALARM_MNGT_FAILURE]: (state, action) => ({
      ...state,
      insertAlarmMngtResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U069. 알람서비스 3번쨰탭 알림관리 상세 조회
    [GET_ALARM_DETAIL_SUCCESS]: (state, action) => ({
      ...state,
      getAlramDetailResp: action.payload,
    }),
    [GET_ALARM_DETAIL_FAILURE]: (state, action) => ({
      ...state,
      getAlramDetailResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U070. 알람서비스 3번쨰탭 알림설정수정
    [SAVE_ALARM_MNGT_SUCCESS]: (state, action) => ({
      ...state,
      saveAlramMngtResp: action.payload,
    }),
    [SAVE_ALARM_MNGT_FAILURE]: (state, action) => ({
      ...state,
      saveAlramMngtResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U071. 알람서비스 3번쨰탭 알람 삭제
    [DELETE_NTCN_INFO_SUCCESS]: (state, action) => ({
      ...state,
      deleteNtcnInfoResp: action.payload,
    }),
    [DELETE_NTCN_INFO_FAILURE]: (state, action) => ({
      ...state,
      deleteNtcnInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U072. 알람서비스 3번쨰탭 알림관리 목록조회
    [GET_NTCN_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getNtcnListResp: action.payload,
    }),
    [GET_NTCN_LIST_FAILURE]: (state, action) => ({
      ...state,
      getNtcnListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U079. 알람서비스 알림 상세에서 삭제시 모두 삭제
    [DELETE_RCV_INFO_ALL_SUCCESS]: (state, action) => ({
      ...state,
      deleteRcvInfoAllResp: action.payload,
    }),
    [DELETE_RCV_INFO_ALL_FAILURE]: (state, action) => ({
      ...state,
      deleteRcvInfoAllResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U080. 서비스 변경 시, 그룹코드 생성 및 서비스데이터 복사 저장 - 접수 X
    [UPDATE_USAGE_STUS_SUCCESS]: (state, action) => ({
      ...state,
      updateUsageStusResp: action.payload,
    }),
    [UPDATE_USAGE_STUS_FAILURE]: (state, action) => ({
      ...state,
      updateUsageStusResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U081. 온라인 연계 몰 리스트
    [GET_MALL_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getMallListResp: action.payload,
    }),
    [GET_MALL_LIST_FAILURE]: (state, action) => ({
      ...state,
      getMallListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U024. 서비스관리 이용현황 이용중인 요금제 보기
    [SELECT_FEE_INFO_SUCCESS]: (state, action) => ({
      ...state,
      selectFeeInfoResp: action.payload,
    }),
    [SELECT_FEE_INFO_FAILURE]: (state, action) => ({
      ...state,
      selectFeeInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U5122. 동일 유통사 내 VanId 중복 체크
    [CHK_OVERLAP_VAN_ID_SUCCESS]: (state, action) => ({
      ...state,
      chkOverLapVanIdResp: action.payload,
    }),
    [CHK_OVERLAP_VAN_ID_FAILURE]: (state, action) => ({
      ...state,
      chkOverLapVanIdResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
  },
  initialState
);

export default apiServiceMngtResp;
